module.exports = __webpack_public_path__ + "static/embryoupload-31ea4f99356ae0fdf907ffbb7c06357e.png";